// Camera utility functions for proctoring system

/**
 * Stop all active camera streams
 * This ensures camera is properly dismissed when assessment ends
 */
export const stopAllCameraStreams = () => {
  try {
    // Stop all existing media tracks
    navigator.mediaDevices.getUserMedia({ video: true, audio: false })
      .then(stream => {
        stream.getTracks().forEach(track => {
          track.stop();
          console.log('📹 Camera track stopped:', track.label);
        });
      })
      .catch(() => {
        // Ignore errors - camera might already be stopped
      });
    
    // Also try to stop any existing video elements
    const videoElements = document.querySelectorAll('video');
    videoElements.forEach(video => {
      if (video.srcObject) {
        const stream = video.srcObject;
        stream.getTracks().forEach(track => track.stop());
        video.srcObject = null;
      }
    });
    
    console.log('✅ All camera streams stopped');
  } catch (error) {
    console.log('⚠️ Error stopping camera streams:', error);
  }
};

/**
 * Check if camera is currently active
 */
export const isCameraActive = () => {
  try {
    const videoElements = document.querySelectorAll('video');
    return Array.from(videoElements).some(video => 
      video.srcObject && 
      video.srcObject.getVideoTracks().some(track => track.readyState === 'live')
    );
  } catch (error) {
    return false;
  }
};